module.exports = __webpack_public_path__ + "pc/img/PC_thumbnail_552x362.bae69c46.png";